import axiosInstance from '@/plugins/api/axiosInstance';
export default function status() {
    return { save };
    function saveReceiptStatus(payload) {
        return axiosInstance.post('receipt/create-status', payload);
    }

    function saveWarehouseStatus(payload) {
        return axiosInstance.post('warehouse-receipt/create-status', payload);
    }

    function saveShipmentStatus(payload) {
        return axiosInstance.post('guide/create-status', payload);
    }

    function saveConsolidatedStatus(payload) {
        return axiosInstance.post('consolidated/create-status', payload);
    }

    function save(payload) {
        if (payload.type === 'receipt') {
            return saveReceiptStatus(payload);
        } else if (payload.type === 'warehouse') {
            return saveWarehouseStatus(payload);
        } else if (payload.type === 'shipment') {
            return saveShipmentStatus(payload);
        } else if (payload.type === 'consolidated') {
            return saveConsolidatedStatus(payload);
        }
    }
}
